import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Government } from '../shared/models/government.model';
import { CountAndResults } from '../shared/types';

@Injectable()
export class GovernmentService {
  private http = inject(HttpClient);


  search(body: any): Observable<CountAndResults> {
    return this.http.post<CountAndResults>('/api/governments/search', body);
  }

  getAll(): Observable<Government[]> {
    return this.http.get<Government[]>('/api/governments');
  }

}
